import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CustomIconButton from '../../../../../../components/CustomIconButton/CustomIconButton';
import CloudUploadIcon from '../../../../../../components/Icons/CloudUploadIcon';
import { uploadContrato } from '../../../../../../store/modules/ContratosActions';
import {
  CONTRATO_ENTE_PUBLICO_ASSINADO_FILE_TYPES,
  CONTRATO_ENTE_PUBLICO_ASSINADO_MAX_FILE_SIZE,
  uploadFileValidation,
} from '../../../../../../utils/ValidationUtils';
import arquivosStyles from '../Arquivos.scss';
import CustomUploadEntePublicoAssinatura from 'components/CustomUploadButton/CustomUploadEntePublicoAssinatura/CustomUploadEntePublicoAssinatura';

class UploadAssinadoButton extends Component {
  getArquivoId = () => {
    return this.props.arquivo.idDocAssinado;
  };

  isShown = () => {
    return (
      (!this.getArquivoId() &&
        this.props.auth.userPermissions.contratos.entePublico.uploadAssinado) ||
      this.props.auth.userPermissions.contratos.entePublico.changeUploadAssinado
    );
  };

  isLoading = () => {
    return this.props.contratosEntePublico.loadingAlteraStatus;
  };

  isDisabled = () => {
    const arquivo = this.props.arquivo;
    return (
      this.isLoading() ||
      this.props.contratosEntePublico.loadingAlteraArquivo ||
      (!this.props.auth.userPermissions.contratos.editEvenWhenDisabled &&
        (!!this.props.arquivo.idDocExtrato ||
          !arquivo.isLatest ||
          !arquivo.idDocNaoAssinado ||
          !arquivo.ativo))
    );
  };

  fileIsValid = (file) => {
    const validation = uploadFileValidation(
      file,
      CONTRATO_ENTE_PUBLICO_ASSINADO_FILE_TYPES,
      CONTRATO_ENTE_PUBLICO_ASSINADO_MAX_FILE_SIZE,
      this.props.languageValues.errorFileTypeContrato,
      this.props.languageValues.errorFileSizeContrato
    );
    return validation;
  };

  uploadAction = (data, callbackProgress, callbackSuccess, callbackError) => {
    this.props.uploadContrato(
      data.file,
      this.props.arquivo.id,
      this.props.arquivo.versaoContrato,
      callbackSuccess,
      callbackError,
      (obj) => callbackProgress(obj.percent)
    );
  };

  render() {
    const arquivo = this.props.arquivo;
    const isAditivo = !!this.props.contratosEntePublico.contratoEditing;
    return arquivo && this.isShown() ? (
      <CustomUploadEntePublicoAssinatura
        id={arquivo.id}
        isAditivo={isAditivo}
        hideLabel
        className={arquivosStyles.rootClassName + '-action-button'}
        buttonComponent={CustomIconButton}
        buttonComponentProps={{
          id: 'upload-assinado-' + arquivo.id,
          name: 'data-cy',
          size: 'small',
          icon: <CloudUploadIcon />,
          theme: 'pufvYellow',
          tooltip:
            this.props.languageValues.cadastroContratoArquivosUploadAssinado,
          tooltipProps: {
            className:
              arquivosStyles.rootClassName + '-action-button-tooltip-caller',
          },
        }}
        fileIsValid={this.fileIsValid}
        uploadAction={this.uploadAction}
        uploadActionData={{}}
        feedbackOnModal
        feedbackOnModalTitle={
          this.props.languageValues.cadastroContratoArquivosUploadingAssinado
        }
        disabled={this.isDisabled()}
        uploadActionSuccessCallback={this.props.refreshStep}
      />
    ) : null;
  }
}

UploadAssinadoButton.propTypes = {
  id: PropTypes.string.isRequired,
  arquivo: PropTypes.object.isRequired,
  refreshStep: PropTypes.func,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  contratosEntePublico: state.contratosEntePublico,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      uploadContrato,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadAssinadoButton);
